import styled from 'styled-components';

export const ProgressTrackerContainer = styled.div`
  display: flex;
`;

export const ProgressDotWrapper = styled.div`
  margin: 0 12px;
`;
